import { render, staticRenderFns } from "./polCollectionPol.vue?vue&type=template&id=ea65fe4a&scoped=true"
import script from "./polCollectionPol.vue?vue&type=script&lang=js"
export * from "./polCollectionPol.vue?vue&type=script&lang=js"
import style0 from "./polCollectionPol.vue?vue&type=style&index=0&id=ea65fe4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea65fe4a",
  null
  
)

export default component.exports